var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"inteligencia"},[_c('vue-iframe',{attrs:{"src":_vm.url,"frame-id":"my-ifram","name":"my-frame"},on:{"load":_vm.onLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }